import React from "react"

export function FigureText({ text }) {
  return (
    <div
      className="text-center text-base mt-10 ml-auto mr-auto"
      style={{ maxWidth: "640px" }}
    >
      {text}
    </div>
  )
}
